import React, { useState, useEffect } from 'react';
import { Formik, Form } from 'formik';
import InputTypeNumber from '../../../common/components/InputTypeNumber/InputTypeNumber';
import withErrorHandler from '../../../hoc/withErrorHandler/withErrorHandler';
import { updateLoanAmount } from '../../../common/constants/api';
import {
  getApplicantionInfo,
  setApplicantionInfo
} from '../../../common/utils/applicantionInfo';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave } from '@fortawesome/pro-light-svg-icons';
import * as Yup from 'yup';
const validationSchema = Yup.object().shape({
  loanAmount: Yup.string().required('Required')
});
function EditLoanAmount(props) {
  const [data, setData] = useState(getApplicantionInfo());
  const { type, text, autoClose, setShow } = props;

  return (
    <Formik
      initialValues={{
        loanAmount: ''
      }}
      validationSchema={validationSchema}
      onSubmit={(data, { setSubmitting }) => {
        setSubmitting(true);
      }}
    >
      {({
        values,
        handleChange,
        errors,
        touched,
        handleBlur,
        setFieldError,
        setFieldValue,
        setFieldTouched,
        handleSubmit,
        isSubmitting
      }) => {
        const updateLoan = () => {
          setShow(true);
          type('loading');
          text('Updating the loan amount');
          updateLoanAmount(data?.leadId, values?.loanAmount)
            .then(res => {
              data.leadData.loanAmount = values?.loanAmount;
              setApplicantionInfo(data);
              setShow(true);
              type('success');
              text('Laon amount has been updated successfully!');
              autoClose(true);
              setTimeout(() => {
                props.setEditloanAmount(false);
              }, 2000);
            })
            .catch(err => {
              setShow(false);
              setTimeout(() => {
                props.setEditloanAmount(false);
              }, 2000);
            });
        };
        useEffect(() => {
          setFieldValue('loanAmount', data?.leadData?.loanAmount, true);
        }, []);
        return (
          <React.Fragment>
            <Form onSubmit={handleSubmit} className="w-full">
              <div className="float-left" style={{ width: '200px' }}>
                <InputTypeNumber
                  name="loanAmount"
                  maxLength={10}
                  minLength={0}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.loanAmount}
                  stylesContainer={{
                    height: '52px',
                    maxWidth: '200px'
                  }}
                  disabled={false}
                  legendName="Loan Amount"
                  error={touched.loanAmount && errors.loanAmount}
                  errorMsg={errors.loanAmount}
                  touched={touched.loanAmount}
                  setFieldValue={setFieldValue}
                  setFieldTouched={setFieldTouched}
                  setFieldError={setFieldError}
                  showInText={false}
                />
              </div>
              <FontAwesomeIcon
                icon={faSave}
                className="cursor-pointer m-4 float-left text-2xl text-green-1000"
                onClick={updateLoan}
              />
            </Form>
          </React.Fragment>
        );
      }}
    </Formik>
  );
}
export default withErrorHandler(EditLoanAmount);
